function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 6h8c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h6l2 2zm.864 7.571c.679 0 1.223-.574 1.223-1.285 0-.712-.544-1.286-1.223-1.286-.68 0-1.228.574-1.228 1.286 0 .711.549 1.285 1.228 1.285zm3.272 0c.68 0 1.224-.574 1.224-1.285 0-.712-.544-1.286-1.224-1.286-.679 0-1.227.574-1.227 1.286 0 .711.548 1.285 1.227 1.285zM10 15.93c0-.999 1.91-1.5 2.864-1.5.953 0 2.863.501 2.863 1.5V17H10v-1.071zm6.136-1.5c-.118 0-.253.008-.396.021.474.36.806.844.806 1.479V17H19v-1.071c0-.999-1.91-1.5-2.864-1.5z",
  fill: "#666"
})));